import type { LevelExtrusion } from "building-types/levels/levelPerimeters";
import type { Table } from "common/data/table";
import type { Vec3 } from "geom/vec3";
import pointInsideLevelExtrusions from "./pointInsideLevelExtrusions";

/**
 * Interior/exterior containment test for a centroid derived from an AABB union.
 *
 * Such a centroid goes NaN if any single sub-geometry is degenerate, because `aabb3Union` builds it
 * with `Math.min`/`Math.max`. NaN then compares false against every bound, so
 * `pointInsideLevelExtrusions` answers "outside" and the whole element is lit as an exterior object
 * — the failure is invisible in the geometry and only shows up as wrong lighting.
 *
 * Returns `undefined` when the centroid is unusable so that callers have to pick a fallback
 * deliberately rather than inheriting "exterior" by accident.
 */
export default function centroidInsideLevelExtrusions(
  levelExtrusions: Table<LevelExtrusion>,
  centroid: Vec3,
): boolean | undefined {
  const [x, y, z] = centroid;

  if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(z)) {
    return undefined;
  }

  return pointInsideLevelExtrusions(levelExtrusions, x, y, z);
}
